import { render, staticRenderFns } from "./FrameDesignOption.vue?vue&type=template&id=6b29c402&lang=pug"
import script from "./FrameDesignOption.vue?vue&type=script&setup=true&lang=ts"
export * from "./FrameDesignOption.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports